/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}div.outerwrap[_ngcontent-%COMP%]{height:100%}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/ssologin/ssologin.component.css.shim.ngstyle.js.pre-build-optimizer.js